import { Injectable } from '@angular/core';

import { getImageSizeThreshold, imageResponsiveSizes, imageResponsiveSizesRaw } from './image-responsive-sizes';
import { ImageSizeType } from './image-size-type.enum';
import { ImageSources } from './image-sources';
import { ImageUrl } from './image-url';
import { ImageUrlOptions } from './image-url-options.interface';

/**
 * NOTE: it looks like this service is used just for sim search. to be removed (and other files in this directory) once sim search removed.
 */
@Injectable({
  providedIn: 'root'
})
export class ImageUrlService {
  /**
   * Format an image url by using given options object
   */
  public format(uri: string, options?: ImageUrlOptions): string {
    if (!uri) {
      return null;
    }
    const url = new ImageUrl(uri);
    url.setOptions(options || url.getOptionsFromUrl(uri));

    return url.toString();
  }

  /**
   * Generate srcset/sizes for given image options
   */
  public formatResponsive(
    uri: string,
    imageType: ImageSizeType,
    options?: ImageUrlOptions,
    optionsPerMq?: ImageUrlOptions[]
  ): ImageSources {
    const widths: number[] = Object.values(imageResponsiveSizesRaw[imageType]);
    return {
      sizes: imageResponsiveSizes[imageType],
      srcSet: widths
        .reduce<string[]>((srcSetArray, width, i) => {
          options = {
            ...options,
            ...(optionsPerMq && widths.length === optionsPerMq.length ? optionsPerMq[i] : {})
          };
          width = getImageSizeThreshold(width);
          const retinaWidth = getImageSizeThreshold(width * 2);
          const modifiedUrl = this.format(uri, { ...options, width });
          const modifiedUrlRetina = this.format(uri, { ...options, width: retinaWidth });
          return [...srcSetArray, `${modifiedUrl} ${width}w`, `${modifiedUrlRetina} ${retinaWidth}w`];
        }, [])
        .join(', ')
    };
  }
}
